import { PAYMENT_PERIODS } from 'modules/Subscriptions/models';

export const usePlansHaveDiscount = (periodicity: string) => {
  const shouldShowDiscountText = periodicity === PAYMENT_PERIODS.YEARLY;
  return shouldShowDiscountText;
};
